<template>
    <fragment>
        <tr v-for="row in rows" :key="row._uid">
            <td>
                <v-skeleton-loader type=" list-item, divider, list-item-three-line" />
            </td>
            <td align="center">
                <v-skeleton-loader max-width="70" type=" text, text, text, text" />
            </td>
            <td v-for="subject in subjects" :key="subject._uid" colspan="3">
                <v-skeleton-loader type="list-item-three-line" />
            </td>
        </tr>
    </fragment>
</template>

<script>
import { Fragment } from "vue-fragment";
import { range } from "lodash";

export default {
    components: {
        Fragment,
    },
    data() {
        return {
            rows: range(10),
        };
    },
    props: ["subjects"],
};
</script>

<style lang="sass" scoped>
tr:not(:last-child)
    border-bottom: 1px solid $color-grey
</style>
